var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('HeaderPage')],1),_c('el-container',{staticClass:"content-area"},[_c('el-aside',{staticClass:"nav-side",attrs:{"width":"220px"}},[_c('MenuPage')],1),_c('el-container',[_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }